// Limpia nombres y apellidos para usarlos en el contenido del QR.
export function sanitizeFullName(input: string | undefined | null): string {
    if (!input) return '';
  
    let s = String(input);
  
    // Normaliza a NFD y elimina diacríticos: áéíóúüñ -> aeiouun (ñ -> n)
    s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  
    // Quita comillas tipográficas y rectas
    s = s.replace(/[\u2018\u2019\u201A\u201B\u2032\u2035'"\u201C\u201D]/g, '');
  
    // Sustituye guiones largos/medianos/underscores por espacio (— – _ − etc.)
    s = s.replace(/[\u2010-\u2015\u2212_-]/g, ' ');
  
    // Elimina caracteres no imprimibles, tabs, retornos, NBSP, ZWSP
    s = s.replace(/[\u00A0\u200B-\u200D\u2060\r\n\t]/g, ' ');
  
    // Elimina emojis y pictográficos extendidos
    s = s.replace(/[\p{Extended_Pictographic}\uFE0F]/gu, '');
  
    // Elimina cualquier cosa que no sea letras ASCII o espacio
    // (tras quitar diacríticos ya tenemos A-Z; admite espacios)
    s = s.replace(/[^A-Za-z\s]/g, '');
  
    // Colapsa espacios múltiples y recorta
    s = s.replace(/\s+/g, ' ').trim();
  
    return s;
}